<!-- ModalMessage.vue -->
<template>
    <div :class="['modal-message-wrap', messageTypeClass]">
      <div v-html="message"></div>
    </div>
  </template>
  
  <script setup lang="ts">
  import { computed } from 'vue';
  import { MessageType } from '@/types/enums.ts';

  const props = defineProps({
    message: {
      type: String,
      required: true,
    },
    type: {
      type: String as () => keyof typeof MessageType,
      default: MessageType.INFO,
      validator: (value: string): boolean => Object.values(MessageType).includes(value as MessageType)
    }
  });
  
  const messageTypeClass = computed(() => {
    switch (props.type) {
      case 'error': return 'error-message';
      case 'warning': return 'warning-message';
      case 'success': return 'success-message';
      case 'info': return 'info-message';
      default: return 'info-message';
    }
  });
  </script>
  
<style lang="scss" scoped>
@import '~/assets/constants.scss';

  .modal-message-wrap {
    min-height: 20px;
  }
  
  .error-message {
    color: $fa-red;
  }
  
  .warning-message {
    color: $fa-orange;
  }
  
  .success-message {
    color: $fa-green;
  }
  
  .info-message {
    color: $fa-blue;
  }

  .modal-message-wrap {
   /* border-radius: $fa-border-radius;
    color: $dark-mode-color;
    text-align: center;
    padding: 0.5rem;
    font-size: 1.125rem;
    margin-bottom: 1rem;*/
  }


  </style>
  